import * as normalize from 'utils/normalize';
import getPatientName from 'utils/print/getPatientName';
import getPatientFullAddress from 'utils/print/getPatientFullAddress';
import getPatientPhone1 from 'utils/print/getPatientPhone1';
import getPatientPhone2 from 'utils/print/getPatientPhone2';
import getPatientPhone3 from 'utils/print/getPatientPhone3';
import getPatientDob from 'utils/print/getPatientDob';
import getPatientGender from 'utils/print/getPatientGender';
import getPatientRecordNumber from 'utils/print/getPatientRecordNumber';
import getInsuranceSignatureOnFile from 'utils/print/getInsuranceSignatureOnFile';
import getInsuranceInsuredsID from 'utils/print/getInsuranceInsuredsID';
import getInsuranceInsuredsName from 'utils/print/getInsuranceInsuredsName';
import getInsuranceInsuredsFullAddress from 'utils/print/getInsuranceInsuredsFullAddress';
import getDiagnosisCode from 'utils/print/getDiagnosisCode';
import getOrderLineDosFrom1 from 'utils/print/getOrderLineDosFrom1';
import getOrderLineDosFrom2 from 'utils/print/getOrderLineDosFrom2';
import getOrderLineDosFrom3 from 'utils/print/getOrderLineDosFrom3';
import getOrderLineDosTo1 from 'utils/print/getOrderLineDosTo1';
import getOrderLineDosTo2 from 'utils/print/getOrderLineDosTo2';
import getOrderLineDosTo3 from 'utils/print/getOrderLineDosTo3';
import getOrderLinePlaceOfService from 'utils/print/getOrderLinePlaceOfService';
import getOrderLineHCPCSCode from 'utils/print/getOrderLineHCPCSCode';
import getOrderLineUnits from 'utils/print/getOrderLineUnits';
import getOrderLineModifiers1 from 'utils/print/getOrderLineModifiers1';
import getOrderLineModifiers2 from 'utils/print/getOrderLineModifiers2';
import getOrderLineModifiers3 from 'utils/print/getOrderLineModifiers3';
import getOrderLineModifiers4 from 'utils/print/getOrderLineModifiers4';
import getOrderLineTotalCharge from 'utils/print/getOrderLineTotalCharge';
import getOrderLineDiagnosis from 'utils/print/getOrderLineDiagnosis';
import getOrderLineDiagnosisPointer from 'utils/print/getOrderLineDiagnosisPointer';
import getOrderLineNarrative from 'utils/print/getOrderLineNarrative';
import getOrderTotalCharge from 'utils/print/getOrderTotalCharge';
import getFacilityNameAndAddress from 'utils/print/getFacilityNameAndAddress';
import getFacilityNPI from 'utils/print/getFacilityNPI';
import getBusinessNPI from 'utils/print/getBusinessNPI';
import getBusinessNameAndAddress from 'utils/print/getBusinessNameAndAddress';
import getPrescriberName from 'utils/print/getPrescriberName';
import getPrescriberNPI from 'utils/print/getPrescriberNPI';
import getOrderLineDosFrom from 'utils/print/getOrderLineDosFrom';
import getDefault from 'utils/print/getDefault';
import getOrderAuthorization from 'utils/print/getOrderAuthorization';
import getOrderResubmission from 'utils/print/getOrderResubmission';
import getOrderOriginalRefNumber from 'utils/print/getOrderOriginalRefNumber';
import getInquiringProviderUserName from 'utils/print/getInquiringProviderUserName';
import getInquiringProviderTaxID from 'utils/print/getInquiringProviderTaxID';
import getCurrentDate from 'utils/print/getCurrentDate';
import getPaymentSource from 'utils/print/getPaymentSource';

const Form150003 = {
  ID: 40,
  Name: '150003 Form (Medicaid)',
  Type: 'Form 1500',
  Format: 'letter',
  Orientation: 'p',
  OrderLineMax: 7,
  WithCharge: true,
  WithBackgroundTemplate: true,
  Pages: [
    {
      ID: 1,
      imageUrl: 'assets/documents/Form150003/1.js',
      fields: [
        {
          name: 'A Code',
          type: 'text',
          x: 113,
          y: 10,
          width: 5,
          maxLength: 1,
        },
        {
          name: 'V Code',
          type: 'text',
          x: 120,
          y: 10,
          width: 5,
          maxLength: 1,
        },
        // {
        //   name: 'Original Transaction Control Number',
        //   type: 'text',
        //   x: 135,
        //   y: 10,
        //   width: 56,
        // },
        {
          name: 'Patient Name',
          type: 'text',
          getValue: getPatientName,
          x: 40,
          y: 17.5,
          width: 42,
          height: 8.5,
          multiline: true,
        },
        {
          name: 'Patient Address',
          type: 'text',
          getValue: props => getPatientFullAddress({ ...props, billing: true }),
          x: 40,
          y: 26.5,
          width: 42,
          height: 15,
          multiline: true,
        },
        {
          name: 'Patient Employer',
          type: 'text',
          x: 40,
          y: 42,
          width: 42,
          height: 8.5,
          multiline: true,
        },
        {
          name: 'Other health insurance coverage',
          type: 'text',
          x: 40,
          y: 55,
          width: 42,
          height: 12.75,
          multiline: true,
        },
        {
          name: 'Patient DOB 1',
          type: 'text',
          getValue: props => getPatientDob({ ...props, slice: [0, 1] }),
          x: 83,
          y: 19.5,
          width: 3,
          maxLength: 1,
          normalize: normalize.number,
        },
        {
          name: 'Patient DOB 2',
          type: 'text',
          getValue: props => getPatientDob({ ...props, slice: [1, 2] }),
          x: 87,
          y: 19.5,
          width: 3,
          maxLength: 1,
          normalize: normalize.number,
        },
        {
          name: 'Patient DOB 3',
          type: 'text',
          getValue: props => getPatientDob({ ...props, slice: [2, 3] }),
          x: 91,
          y: 19.5,
          width: 3,
          maxLength: 1,
          normalize: normalize.number,
        },
        {
          name: 'Patient DOB 4',
          type: 'text',
          getValue: props => getPatientDob({ ...props, slice: [3, 4] }),
          x: 95,
          y: 19.5,
          width: 3,
          maxLength: 1,
          normalize: normalize.number,
        },
        {
          name: 'Patient DOB 5',
          type: 'text',
          getValue: props => getPatientDob({ ...props, slice: [4, 5] }),
          x: 99,
          y: 19.5,
          width: 3,
          maxLength: 1,
          normalize: normalize.number,
        },
        {
          name: 'Patient DOB 6',
          type: 'text',
          getValue: props => getPatientDob({ ...props, slice: [5, 6] }),
          x: 103,
          y: 19.5,
          width: 3,
          maxLength: 1,
          normalize: normalize.number,
        },
        {
          name: 'Patient DOB 7',
          type: 'text',
          getValue: props => getPatientDob({ ...props, slice: [6, 7] }),
          x: 106.5,
          y: 19.5,
          width: 3,
          maxLength: 1,
          normalize: normalize.number,
        },
        {
          name: 'Patient DOB 8',
          type: 'text',
          getValue: props => getPatientDob({ ...props, slice: [7, 8] }),
          x: 110,
          y: 19.5,
          width: 3,
          maxLength: 1,
          normalize: normalize.number,
        },
        {
          name: 'Family income',
          x: 112.5,
          y: 20,
          width: 20,
        },
        {
          name: 'Insured Gender',
          type: 'radio',
          options: [
            {
              x: 87.5,
              y: 29.5,
              width: 4,
              height: 4,
              value: 'M',
            },
            {
              x: 96,
              y: 29.5,
              width: 4,
              height: 4,
              value: 'F',
            },
          ],
        },
        {
          name: 'Patient Gender',
          type: 'radio',
          getValue: getPatientGender,
          options: [
            {
              x: 110.5,
              y: 29.5,
              width: 4,
              height: 4,
              value: 'M',
            },
            {
              x: 118.5,
              y: 29.5,
              width: 4,
              height: 4,
              value: 'F',
            },
          ],
        },
        {
          name: 'Patient Phone 1',
          type: 'text',
          getValue: getPatientPhone1,
          x: 83,
          y: 36.5,
          width: 7.5,
          maxLength: 3,
          normalize: normalize.number,
        },
        {
          name: 'Patient Phone 2',
          type: 'text',
          getValue: getPatientPhone2,
          x: 94,
          y: 36.5,
          width: 7.5,
          maxLength: 3,
          normalize: normalize.number,
        },
        {
          name: 'Patient Phone 3',
          type: 'text',
          getValue: getPatientPhone3,
          x: 103,
          y: 36.5,
          width: 12,
          maxLength: 4,
          normalize: normalize.number,
        },
        {
          name: 'Patient relationship to insured',
          type: 'radio',
          options: [
            {
              x: 87,
              y: 47,
              width: 7,
              height: 3,
              value: 'Self',
            },
            {
              x: 97,
              y: 47,
              width: 7,
              height: 3,
              value: 'Spouse',
            },
            {
              x: 107,
              y: 47,
              width: 7,
              height: 3,
              value: 'Child',
            },
            {
              x: 117.5,
              y: 47,
              width: 7,
              height: 3,
              value: 'Other',
            },
          ],
        },
        {
          name: 'Was condition related to',
          type: 'radio',
          options: [
            {
              x: 97.5,
              y: 54,
              width: 5,
              height: 3,
              value: 'Employment',
            },
            {
              x: 106.5,
              y: 54,
              width: 5,
              height: 3,
              value: 'Crime',
            },
            {
              x: 97.5,
              y: 63,
              width: 5,
              height: 3,
              value: 'Auto',
            },
            {
              x: 106.5,
              y: 63,
              width: 5,
              height: 3,
              value: 'Other',
            },
          ],
        },
        {
          name: 'Insureds Name',
          type: 'text',
          x: 137,
          y: 19,
          width: 70,
        },
        {
          name: 'Insureds Medicare Number',
          type: 'text',
          getValue: props => getInsuranceInsuredsID({ ...props, type: 'Medicare' }),
          x: 132,
          y: 27.5,
          width: 27,
        },
        ...[0, 1, 2, 3, 4, 5, 6, 7].reduce((accumulator, currentValue) => {
          const x = 167.25 + (currentValue * 3.7);
          return [
            ...accumulator,
            {
              name: `Insureds Medicaid Number ${currentValue}`,
              type: 'text',
              getValue: (props) => {
                const value = getInsuranceInsuredsID({ ...props, type: 'Medicaid' });
                if (value) {
                  return value.length > 1 ? value.slice(currentValue, currentValue + 1) : value;
                }
                return '';
              },
              x,
              y: 28,
              width: 3.5,
            }
          ];
        }, []),
        {
          name: 'Insureds Private Insurance Number',
          type: 'text',
          getValue: props => getInsuranceInsuredsID({ ...props, type: 'Private' }),
          x: 132,
          y: 37,
          width: 27,
        },
        {
          name: 'Insureds Group',
          type: 'text',
          x: 167,
          y: 37,
          width: 19,
        },
        {
          name: 'Insureds Reciprocity',
          type: 'text',
          x: 187.5,
          y: 37,
          width: 19,
        },
        {
          name: 'Insureds Employer or occupation',
          type: 'text',
          x: 130,
          y: 44,
          width: 77,
        },
        {
          name: 'Insureds Full Address',
          type: 'text',
          multiline: true,
          x: 130,
          y: 52,
          width: 77,
          height: 14,
        },
        {
          name: 'Signature Date 1',
          type: 'text',
          x: 106,
          y: 75,
          width: 6,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Signature Date 2',
          type: 'text',
          x: 113,
          y: 75,
          width: 6,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Signature Date 3',
          type: 'text',
          x: 121,
          y: 75,
          width: 6,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Name of referring provider or other source',
          type: 'text',
          getValue: getPrescriberName,
          x: 6,
          y: 95,
          width: 74,
        },
        {
          name: 'Prescriber Address',
          type: 'text',
          x: 81,
          y: 95,
          width: 47,
        },
        {
          name: 'Prescriber Prof CD',
          type: 'text',
          x: 131,
          y: 95,
          width: 10,
        },
        ...[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].reduce((accumulator, currentValue) => {
          const x = 143.5 + (currentValue * 4.1);
          return [
            ...accumulator,
            {
              name: `Prescriber NPI ${currentValue}`,
              type: 'text',
              getValue: (props) => {
                const value = getPrescriberNPI(props);
                if (value) {
                  return value.length > 1 ? value.slice(currentValue, currentValue + 1) : value;
                }
                return '';
              },
              x,
              y: 95.5,
              width: 3.5,
            }
          ];
        }, []),
        {
          name: 'DX Code',
          type: 'text',
          x: 185,
          y: 95,
          width: 20,
        },
        {
          name: 'Possible disability',
          type: 'radio',
          getValue: props => getDefault({ ...props, defaultValue: 'N' }),
          options: [
            {
              x: 141,
              y: 128,
              width: 4,
              height: 5,
              value: 'Y',
            },
            {
              x: 146,
              y: 128,
              width: 4,
              height: 5,
              value: 'N',
            },
          ],
        },
        ...[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].reduce((accumulator, currentValue) => {
          const x = 132 + (currentValue * 5.1);
          return [
            ...accumulator,
            {
              name: `Prior Auth ${currentValue}`,
              type: 'text',
              getValue: (props) => {
                const value = getOrderAuthorization(props);
                if (value) {
                  return value.length > 1 ? value.slice(currentValue, currentValue + 1) : value;
                }
                return '';
              },
              x,
              y: 138,
              width: 4,
            }
          ];
        }, []),
        {
          name: 'Payment Source 1',
          type: 'text',
          getValue: (props) => {
            const value = getPaymentSource(props);
            if (value) {
              return value.length > 1 ? value.slice(0, 1) : value;
            }
            return '';
          },
          x: 188,
          y: 138,
          width: 4,
        },
        {
          name: 'Payment Source 2',
          type: 'text',
          getValue: (props) => {
            const value = getPaymentSource(props);
            if (value) {
              return value.length > 1 ? value.slice(1, 2) : value;
            }
            return '';
          },
          x: 193,
          y: 138,
          width: 4,
        },
        {
          name: 'Diagnosis 1',
          type: 'text',
          getValue: props => getDiagnosisCode({ ...props, index: 0 }),
          x: 7,
          y: 129,
          width: 17,
        },
        {
          name: 'Diagnosis 2',
          type: 'text',
          getValue: props => getDiagnosisCode({ ...props, index: 1 }),
          x: 7,
          y: 133,
          width: 17,
        },
        {
          name: 'Diagnosis 3',
          type: 'text',
          getValue: props => getDiagnosisCode({ ...props, index: 2 }),
          x: 7,
          y: 137,
          width: 17,
        },
        {
          name: 'Diagnosis 4',
          type: 'text',
          getValue: props => getDiagnosisCode({ ...props, index: 3 }),
          x: 26,
          y: 129,
          width: 17,
        },
        {
          name: 'Diagnosis 5',
          type: 'text',
          getValue: props => getDiagnosisCode({ ...props, index: 4 }),
          x: 26,
          y: 133,
          width: 17,
        },
        {
          name: 'Diagnosis 6',
          type: 'text',
          getValue: props => getDiagnosisCode({ ...props, index: 5 }),
          x: 26,
          y: 137,
          width: 17,
        },
        {
          name: 'Diagnosis 7',
          type: 'text',
          getValue: props => getDiagnosisCode({ ...props, index: 6 }),
          x: 45,
          y: 129,
          width: 17,
        },
        {
          name: 'Diagnosis 8',
          type: 'text',
          getValue: props => getDiagnosisCode({ ...props, index: 7 }),
          x: 45,
          y: 133,
          width: 17,
        },
        {
          name: 'Diagnosis 9',
          type: 'text',
          getValue: props => getDiagnosisCode({ ...props, index: 8 }),
          x: 45,
          y: 137,
          width: 17,
        },
        {
          name: 'Diagnosis 10',
          type: 'text',
          getValue: props => getDiagnosisCode({ ...props, index: 9 }),
          x: 64,
          y: 129,
          width: 17,
        },
        {
          name: 'Diagnosis 11',
          type: 'text',
          getValue: props => getDiagnosisCode({ ...props, index: 10 }),
          x: 64,
          y: 133,
          width: 17,
        },
        {
          name: 'Diagnosis 12',
          type: 'text',
          getValue: props => getDiagnosisCode({ ...props, index: 11 }),
          x: 64,
          y: 137,
          width: 17,
        },
        ...[0, 1, 2, 3, 4, 5, 6].reduce((accumulator, currentValue) => {
          const y = 155.5 + (currentValue * 8.5);
          return [
            ...accumulator,
            {
              name: `Date of Service From 1 ${currentValue}`,
              type: 'text',
              getValue: (props) => {
                const value = getOrderLineDosFrom1({ ...props, index: currentValue });
                if (value) {
                  return value.length > 1 ? value.slice(0, 1) : value;
                }
                return '';
              },
              x: 5,
              y,
              width: 2.5,
              maxLength: 1,
              normalize: normalize.number,
            },
            {
              name: `Date of Service From 2 ${currentValue}`,
              type: 'text',
              getValue: (props) => {
                const value = getOrderLineDosFrom1({ ...props, index: currentValue });
                if (value) {
                  return value.length > 1 ? value.slice(1, 2) : value;
                }
                return '';
              },
              x: 7.5,
              y,
              width: 2.5,
              maxLength: 1,
              normalize: normalize.number,
            },
            {
              name: `Date of Service From 3 ${currentValue}`,
              type: 'text',
              getValue: (props) => {
                const value = getOrderLineDosFrom2({ ...props, index: currentValue });
                if (value) {
                  return value.length > 1 ? value.slice(0, 1) : value;
                }
                return '';
              },
              x: 11.5,
              y,
              width: 2.5,
              maxLength: 1,
              normalize: normalize.number,
            },
            {
              name: `Date of Service From 4 ${currentValue}`,
              type: 'text',
              getValue: (props) => {
                const value = getOrderLineDosFrom2({ ...props, index: currentValue });
                if (value) {
                  return value.length > 1 ? value.slice(1, 2) : value;
                }
                return '';
              },
              x: 15,
              y,
              width: 2.5,
              maxLength: 1,
              normalize: normalize.number,
            },
            {
              name: `Date of Service From 5 ${currentValue}`,
              type: 'text',
              getValue: (props) => {
                const value = getOrderLineDosFrom3({ ...props, index: currentValue });
                if (value) {
                  return value.length > 1 ? value.slice(0, 1) : value;
                }
                return '';
              },
              x: 19,
              y,
              width: 2.5,
              maxLength: 1,
              normalize: normalize.number,
            },
            {
              name: `Date of Service From 6 ${currentValue}`,
              type: 'text',
              getValue: (props) => {
                const value = getOrderLineDosFrom3({ ...props, index: currentValue });
                if (value) {
                  return value.length > 1 ? value.slice(1, 2) : value;
                }
                return '';
              },
              x: 22.5,
              y,
              width: 2.5,
              maxLength: 1,
              normalize: normalize.number,
            },
            {
              name: `Place of Service 1 ${currentValue}`,
              type: 'text',
              getValue: (props) => {
                const value = getOrderLinePlaceOfService({ ...props, index: currentValue });
                if (value) {
                  return value.toString().length > 1 ? value.toString().slice(0, 1) : value;
                }
                return '';
              },
              x: 26.5,
              y,
              width: 3,
              normalize: normalize.number,
              maxLength: 1,
            },
            {
              name: `Place of Service 2 ${currentValue}`,
              type: 'text',
              getValue: (props) => {
                const value = getOrderLinePlaceOfService({ ...props, index: currentValue });
                if (value) {
                  return value.toString().length > 1 ? value.toString().slice(1, 2) : value;
                }
                return '';
              },
              x: 30.5,
              y,
              width: 3,
              normalize: normalize.number,
              maxLength: 1,
            },
            ...[0, 1, 2, 3, 4].reduce((filedAccumulator, fieldCurrentValue) => {
              const x = 33.6 + (fieldCurrentValue * 3.1);
              return [
                ...filedAccumulator,
                {
                  name: `HCPCS C ${fieldCurrentValue} ${currentValue}`,
                  type: 'text',
                  getValue: (props) => {
                    const value = getOrderLineHCPCSCode({ ...props, index: currentValue });
                    if (value) {
                      return value.toString().length > 1 ? value.toString().slice(fieldCurrentValue, fieldCurrentValue + 1) : value;
                    }
                    return '';
                  },
                  x,
                  y,
                  width: 3.5,
                  maxLength: 1,
                }
              ];
            }, []),
            {
              name: `Modifiers 1 ${currentValue}`,
              type: 'text',
              getValue: (props) => {
                const value = getOrderLineModifiers1({ ...props, index: currentValue });
                if (value) {
                  return value.toString().length > 1 ? value.toString().slice(0, 1) : value;
                }
                return '';
              },
              x: 49.25,
              y,
              width: 4,
              maxLength: 1,
            },
            {
              name: `Modifiers 2 ${currentValue}`,
              type: 'text',
              getValue: (props) => {
                const value = getOrderLineModifiers1({ ...props, index: currentValue });
                if (value) {
                  return value.toString().length > 1 ? value.toString().slice(1, 2) : value;
                }
                return '';
              },
              x: 53,
              y,
              width: 4,
              maxLength: 1,
            },
            {
              name: `Modifiers 3 ${currentValue}`,
              type: 'text',
              getValue: (props) => {
                const value = getOrderLineModifiers2({ ...props, index: currentValue });
                if (value) {
                  return value.toString().length > 1 ? value.toString().slice(0, 1) : value;
                }
                return '';
              },
              x: 57,
              y,
              width: 4,
              maxLength: 1,
            },
            {
              name: `Modifiers 4 ${currentValue}`,
              type: 'text',
              getValue: (props) => {
                const value = getOrderLineModifiers2({ ...props, index: currentValue });
                if (value) {
                  return value.toString().length > 1 ? value.toString().slice(1, 2) : value;
                }
                return '';
              },
              x: 60.6,
              y,
              width: 4,
              maxLength: 1,
            },
            {
              name: `Modifiers 5 ${currentValue}`,
              type: 'text',
              getValue: (props) => {
                const value = getOrderLineModifiers3({ ...props, index: currentValue });
                if (value) {
                  return value.toString().length > 1 ? value.toString().slice(0, 1) : value;
                }
                return '';
              },
              x: 64.4,
              y,
              width: 4,
              maxLength: 1,
            },
            {
              name: `Modifiers 6 ${currentValue}`,
              type: 'text',
              getValue: (props) => {
                const value = getOrderLineModifiers3({ ...props, index: currentValue });
                if (value) {
                  return value.toString().length > 1 ? value.toString().slice(1, 2) : value;
                }
                return '';
              },
              x: 68.1,
              y,
              width: 4,
              maxLength: 1,
            },
            {
              name: `Modifiers 7 ${currentValue}`,
              type: 'text',
              getValue: (props) => {
                const value = getOrderLineModifiers4({ ...props, index: currentValue });
                if (value) {
                  return value.toString().length > 1 ? value.toString().slice(0, 1) : value;
                }
                return '';
              },
              x: 72.4,
              y,
              width: 4,
              maxLength: 1,
            },
            {
              name: `Modifiers 8 ${currentValue}`,
              type: 'text',
              getValue: (props) => {
                const value = getOrderLineModifiers4({ ...props, index: currentValue });
                if (value) {
                  return value.toString().length > 1 ? value.toString().slice(1, 2) : value;
                }
                return '';
              },
              x: 76.1,
              y,
              width: 4,
              maxLength: 1,
            },       
            ...[0, 1, 2, 3, 4, 5, 6].reduce((filedAccumulator, fieldCurrentValue) => {
              const x = 80.5 + (fieldCurrentValue * 3.9);
              return [
                ...filedAccumulator,
                {
                  name: `Order Line Diagnosis ${fieldCurrentValue} ${currentValue}`,
                  type: 'text',
                  getValue: (props) => {
                    const value = getOrderLineDiagnosis({ ...props, index: currentValue });
                    if (value) {
                      return value.toString().length > 1 ? value.toString().replaceAll('.', '').slice(fieldCurrentValue, fieldCurrentValue + 1) : value;
                    }
                    return '';
                  },
                  x,
                  y,
                  width: 3.5,
                  maxLength: 1,
                },
              ];
            }, []),
            ...[0, 1, 2, 3, 4, 5].reduce((filedAccumulator, fieldCurrentValue) => {
              const x = 127 - (fieldCurrentValue * 3.8);
              return [
                ...filedAccumulator,
                {
                  name: `Qty ${fieldCurrentValue} ${currentValue}`,
                  type: 'text',
                  getValue: (props) => {
                    const value = getOrderLineUnits({ ...props, index: currentValue });
                    if (value) {
                      return typeof value === 'number'
                        ? value.toString().split('').reverse().join('').slice(fieldCurrentValue, fieldCurrentValue + 1) : value;
                    }
                    return '';
                  },
                  x,
                  y,
                  width: 2.5,
                  maxLength: 1,
                },
              ];
            }, []),
            ...[0, 1, 2, 3, 4].reduce((filedAccumulator, fieldCurrentValue) => {
              const x = 146.5 - (fieldCurrentValue * 3.8);
              return [
                ...filedAccumulator,
                {
                  name: `Charge Dollars ${fieldCurrentValue} ${currentValue}`,
                  type: 'text',
                  getValue: (props) => {
                    const value = getOrderLineTotalCharge({ ...props, index: currentValue, part: 'dollars' });
                    if (value) {
                      return typeof value === 'number'
                        ? value.toString().split('').reverse().join('').slice(fieldCurrentValue, fieldCurrentValue + 1) : value;
                    }
                    return '';
                  },
                  x,
                  y,
                  width: 2.5,
                  normalize: normalize.number,
                  chargeField: true,
                  maxLength: 1,
                },
              ];
            }, []),
            {
              name: `Charge Cents 1 ${currentValue}`,
              type: 'text',
              getValue: (props) => {
                const value = getOrderLineTotalCharge({ ...props, index: currentValue, part: 'cents' });
                if (value) {
                  return value.toString().length > 1
                    ? value.toString().split('').reverse().join('').slice(0, 1) : value;
                }
                return '';
              },
              x: 150.5,
              y,
              width: 3,
              maxLength: 1,
              normalize: normalize.number,
              chargeField: true,
            },
            {
              name: `Charge Cents 2 ${currentValue}`,
              type: 'text',
              getValue: (props) => {
                const value = getOrderLineTotalCharge({ ...props, index: currentValue, part: 'cents' });
                if (value) {
                  return value.toString().length > 1
                    ? value.toString().split('').reverse().join('').slice(1, 2) : value;
                }
                return '';
              },
              x: 154,
              y,
              width: 3,
              maxLength: 1,
              normalize: normalize.number,
              chargeField: true,
            },
          ];
        }, []),



        {
          name: 'Accept Assignment',
          type: 'radio',
          getValue: props => getDefault({ ...props, defaultValue: 'Yes' }),
          options: [
            {
              x: 92,
              y: 223,
              width: 4,
              height: 4,
              value: 'Yes',
            },
            {
              x: 115,
              y: 223,
              width: 4,
              height: 4,
              value: 'No',
            },
          ],
        },
        {
          name: 'Total charge dollars',
          type: 'text',
          getValue: props => getOrderTotalCharge({ ...props, part: 'dollars' }),
          x: 129,
          y: 223,
          width: 16,
          textAlign: 'right',
          normalize: normalize.number,
          chargeField: true,
        },
        {
          name: 'Total charge cents',
          type: 'text',
          getValue: props => getOrderTotalCharge({ ...props, part: 'cents' }),
          x: 147,
          y: 223,
          width: 7,
          maxLength: 2,
          normalize: normalize.number,
          chargeField: true,
        },
        {
          name: 'Amount paid dollars',
          type: 'text',
          x: 158,
          y: 223,
          width: 14,
          textAlign: 'right',
          normalize: normalize.number,
        },
        {
          name: 'Amount paid cents',
          type: 'text',
          x: 173,
          y: 223,
          width: 6,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Balance due dollars',
          type: 'text',
          x: 184,
          y: 223,
          width: 16,
          textAlign: 'right',
          normalize: normalize.number,
        },
        {
          name: 'Balance Due cents',
          type: 'text',
          x: 201,
          y: 223,
          width: 6,
          maxLength: 2,
          normalize: normalize.number,
        },
        ...[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].reduce((accumulator, currentValue) => {
          const x = 6 + (currentValue * 5.3);
          return [
            ...accumulator,
            {
              name: `Provider NPI ${currentValue}`,
              type: 'text',
              getValue: (props) => {
                const value = getFacilityNPI(props);
                if (value) {
                  return value.length > 1 ? value.slice(currentValue, currentValue + 1) : value;
                }
                return '';
              },
              x,
              y: 240,
              width: 3.5,
            }
          ];
        }, []),
        {
          name: 'Service Facility location information',
          type: 'text',
          getValue: getFacilityNameAndAddress,
          x: 129,
          y: 230,
          width: 77,
          height: 17.3,
          multiline: true,
        },
        {
          name: 'Locator Code 1',
          type: 'text',
          getValue: props => getDefault({ ...props, defaultValue: '0' }),
          x: 59.5,
          y: 248.5,
          width: 4,
          normalize: normalize.number,
          maxLength: 1,
        },
        {
          name: 'Locator Code 2',
          type: 'text',
          getValue: props => getDefault({ ...props, defaultValue: '0' }),
          x: 65,
          y: 248.5,
          width: 4,
          normalize: normalize.number,
          maxLength: 1,
        },
        {
          name: 'Locator Code 3',
          type: 'text',
          getValue: props => getDefault({ ...props, defaultValue: '3' }),
          x: 70.5,
          y: 248.5,
          width: 4,
          normalize: normalize.number,
          maxLength: 1,
        },
        {
          name: 'Date Signed 1',
          type: 'text',
          getValue: (props) => {
            const value = getCurrentDate(props);
            if (value) {
              return value.length > 2 ? value.replaceAll('/', '').slice(0, 2) : value;
            }
            return '';
          },
          x: 31,
          y: 257,
          width: 6,
          normalize: normalize.number,
          maxLength: 2,
        },
        {
          name: 'Date Signed 2',
          type: 'text',
          getValue: (props) => {
            const value = getCurrentDate(props);
            if (value) {
              return value.length > 2 ? value.replaceAll('/', '').slice(2, 4) : value;
            }
            return '';
          },
          x: 39,
          y: 257,
          width: 6,
          normalize: normalize.number,
          maxLength: 2,
        },
        {
          name: 'Date Signed 3',
          type: 'text',
          getValue: (props) => {
            const value = getCurrentDate(props);
            if (value) {
              return value.length > 2 ? value.replaceAll('/', '').slice(4, 6) : value;
            }
            return '';
          },
          x: 46,
          y: 257,
          width: 6,
          normalize: normalize.number,
          maxLength: 2,
        },
      ],
    },
  ],
};

export default Form150003;



// WEBPACK FOOTER //
// ./src/config/documents/Form150003.js